<template>
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap srchQna_wrap pb20">
                <article class="srch_basic">
                    <dl class="dl_search">
                        <dd data-input-type="select">
                            <select class="slt_white w100p" v-model="searchPopupYN">
                                <option value="">All</option>
                                <option value="Y">Popup</option>
                                <option value="N">General</option>
                            </select>
                        </dd>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                v-model="searchTitle"
                                v-clearable
                            />
                        </dd>
                        <dd class="btn">
                            <a href="javascript:" class="btn_srch" @click="onSearchButtonClick">Search</a>
                        </dd>
                    </dl>
                </article>
            </div>
            <!-- Grid -->
            <div>
                <!-- Grid -->
                <div class="grid_wrap">
                    <!-- Grid Count-->
                    <div class="grid_total">
                        Total Count
                        <em>{{ resultCount | numberFormat }}</em>
                    </div>
                    <!-- Grid "btn-->
                    <div class="btn_wrap">
                        <a href="javascript:" class="btn_gray" title @click="onCreateButtonClick">Create</a>
                    </div>
                    <div id="grid">
                        <toast-grid
                            gridId="gridNoticeList"
                            :key="gridKey"
                            :data="gridData"
                            :columns="gridColumns"
                            :options="gridOptions"
                            :pageOptions="gridPageOptions"
                            :theme="gridTheme"
                            :isTotalCount="false"
                            v-bind:click="onRowClick"
                        />
                    </div>
                </div>
                <div class="paginate">
                    <sdl-pagination
                        :current-page="currentPage"
                        :total-rows="resultCount"
                        :per-page="perPage"
                        @change="doSearch"
                        align="center"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

import axios from 'axios';
import qs from 'query-string';
import moment from 'moment';
// import 'tui-date-picker/dist/tui-date-picker.css';
// import DatePicker from 'tui-date-picker';

import { SDLUtil, DateUtil } from '@/utils';

import DatePicker from '~c/DatePicker';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';



export default {
    name: 'adminNoticeList',
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    data() {
        return {
            ...mapGetters({
                locale: 'getLocale',
            }),
            
            pageTitle: 'Notice',

            searchTitle: '',
            searchPopupYN: '',
            // searchRhqCode: '',
            // searchCorpCode: '',

            searchSubsidiaries: '',

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],
            gridColumns: [
                {
                    header: 'Subsidiary',
                    name: 'SUBSIDIARY',
                    align: 'center',
                    width: 160,
                    sortable: false,
                },
                {
                    header: 'Subject',
                    name: 'TITLE',
                    align: 'left',
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Registered by',
                    name: 'REGUSERNAME',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: 'Popup',
                    name: 'POPUPYN',
                    align: 'center',
                    width: 70,
                    sortable: false,
                },
                {
                    header: 'Period',
                    name: 'DATE',
                    align: 'center',
                    sortable: false,
                },
                {
                    header: 'Status',
                    name: 'STATUS',
                    align: 'center',
                    width: 150,
                    sortable: true,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
        };
    },
    created() {
        this.init();
    },
    mounted() {},
    methods: {

        async init() {
            SDLUtil.showLoadingBar(true);
            this.searchSubsidiaries = this.getCompanyName();
            await this.fetchInitData()
                .then(data => {
                    // this.searchRhqCode = data.searchRhqCode;
                    // this.searchCorpCode = data.searchCorpCode;
                })
                .catch(err => {
                    Vue.$log.error('error', err);
                });

            SDLUtil.showLoadingBar(false);
        },

        getCompanyName() {
            return JSON.parse(localStorage.getItem('loginUser')).companyName;
        },

        fetchInitData() {
            return (
                axios
                    .get(`${SDLUtil.API_URL}/basis/admin/other/notice/NoticeList.skp`)
                    .then(res => {
                        return res.data;
                    })
            );
        },

        onSearchButtonClick() {
            this.doSearch(1);
        },

        async doSearch(pageNo) {
            const params = {
                page: pageNo,
                searchTitle: this.searchTitle,
                // searchCorpCode: this.searchCorpCode,
                // searchRhqCode: this.searchRhqCode,
                searchSubsidiaries: this.searchSubsidiaries,
                searchPopupYN: this.searchPopupYN,
            };

            await this.fetchSearch(params)
                .then(res => {
                    // console.log('result', res.data);
                    this.setSearchResult(res.data);
                    this.currentPage = pageNo;

                })
                .catch(err => {
                    console.error('err', err);
                });
        },
        setSearchResult(data) {
            this.resultCount = data.count;
            this.gridData = data.rows.map(item => {
                if (item.STARTDATE && item.ENDDATE) {
                    item.DATE = `${item.STARTDATE} - ${item.ENDDATE}`;
                }
                item.STATUS = item.STATUS === 'N' ? 'Normal' : 'Important';
                return item;
            });
            this.gridKey += 1;

        },
        fetchSearch(params) {
            const formData = qs.stringify(params);
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/other/notice/NoticeSearch.skp`, formData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(res => {
                    return res;
                });
        },

        onRowClick(event, rowData) {
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            // console.log('event row', rowData[event.rowKey]);
            this.editContent(row.NOTICESEQ.toString());
        },

        editContent(seq) {
            this.$router.push({
                name: 'NoticeManagementModify',
                query: { seq },
            });
        },

        onCreateButtonClick() {
            this.$router.push({path: '/basis/admin/other/notice/NoticeCreate'});
        },
    },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/other/NoticeList.vue